import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView, BaseText } from '@/components/base'
import { useSavingsStore } from '@/store/useSavingsStore'
import { useUserStore } from '@/store/useUserStore'
import { useGetWallet } from '@/domain'
import { currencyUtils } from '@/utils'

const { formatDynamicCurrency, cryptoToBig, cryptoToFiat } = currencyUtils

export const FirstDepositMaximumButton: React.FC = () => {
  const { t } = useTranslation()

  const setGoalTransferIn = useSavingsStore((state) => state.setGoalTransferIn)
  const user = useUserStore((s) => s.user)
  const displayCurrency = user?.display_currency || 'USD'

  // Получаем данные кошелька
  const { data: walletData } = useGetWallet()
  const completeCurrencies = useUserStore((s) => s.wallet?.completeCurrencies)

  // Находим USDT кошелек
  const allCurrencies =
    walletData?.completeCurrencies || completeCurrencies || []
  const selectedCryptoWalletData = allCurrencies.find(
    (currency) => currency.code === 'USDT',
  )

  if (!selectedCryptoWalletData) {
    return null
  }

  const handlePress = () => {
    // Логика аналогичная WithdrawMaximumButton
    const bigAmount = cryptoToBig({
      amount: selectedCryptoWalletData.amount ?? '0',
    })

    const fiatAmount = cryptoToFiat({
      amountCrypto: Number(selectedCryptoWalletData.amount ?? '0'),
      cryptoPricePerUnit: selectedCryptoWalletData.pricePerUnit ?? 0,
    })

    // Устанавливаем режим крипто
    setGoalTransferIn({
      isFiatMode: false,
      cryptoAmount: {
        amount: bigAmount,
        code: selectedCryptoWalletData.code ?? 'USDT',
      },
      fiatAmount: {
        amount: fiatAmount,
        code: displayCurrency,
      },
    })
  }

  // Форматируем сумму для отображения
  const formattedAmount = formatDynamicCurrency({
    amount: selectedCryptoWalletData.amount ?? '0',
    currencyCode: selectedCryptoWalletData.code ?? 'USDT',
  })

  const availableAmount = `Maximum: ${formattedAmount}`

  return (
    <BaseView center>
      <div
        onClick={handlePress}
        style={{ alignSelf: 'center', cursor: 'pointer' }}
        className="transition-opacity duration-200 hover:opacity-80"
      >
        <BaseText
          fontSize={14}
          fontFamily="medium"
          color="label.clickable"
          textAlign="center"
        >
          {availableAmount}
        </BaseText>
      </div>
    </BaseView>
  )
}
